let e=Date.now();const t=(t="field")=>(e+=1,`${t}-${e}`);export{t as getUniqueId};
//# sourceMappingURL=idGenerator.js.map
